import { AJOUTE_CRENEAU, SUPRIMER_CRENEAU } from '../types/typeCreneau';

export const ajouteCreneau = (creneau) => {
    return {
        type: AJOUTE_CRENEAU,
        payload: creneau
    }
}

export const suprimerCreneau = () => {
    return {
        type: SUPRIMER_CRENEAU,
        payload: []
    }
}